import {
    addBug,
    completeBug,
    editBug
} from "../../Home/actions";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";

export default [{
    "path": "/Admin/Bugs",
    "component": { ...ItemListView },
    "name": "Bugs & Enhancements",
    "meta": {
        "app": "Admin",
        "sideNav": true,
        "name": "Bugs & Enhancements",
        "sideNavSection": "Admin",
        "sideNavPosition": 4,
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "Bugs",
        "dataPath": "Home/Bugs",
        "selectionRoute": "Admin/Bugs/{ID}",
        filter(item) {
            return item.Status !== "Done";
        },
        lock(user) {
            return [
                user?.Security?.General?.ApplicationAdmin !== true && user?.Security?.General?.UserAdmin !== true,
                "Cannot view this area"
            ];
        },
        hidden(user) {
            return user?.Security?.General?.ApplicationAdmin !== true && user?.Security?.General?.UserAdmin !== true;
        },
        "menuActions": [{
            "label": "Add Bug",
            "action": addBug
        }]
    }
}, {
    "path": "/Admin/Bugs/:id",
    "component": ItemView,
    "name": "Bug",
    "meta": {
        "app": "Admin",
        "name": "Bug",
        "dataPathOverride": "Home/Bugs/:id",
        "selectionRoute": "Admin/Bugs/{ID}",
        lock(user) {
            return [
                user?.Security?.General?.ApplicationAdmin !== true && user?.Security?.General?.UserAdmin !== true,
                "Cannot view this area"
            ];
        },
        title(item) {
            return "Bug"
        },
        "dataFields": [{
            "label": "Raised By",
            "key": "User.Name"
        }, {
            "label": "App / Section",
            "key": "Section"
        }, {
            "label": "Status",
            "key": "Status"
        }, {
            "label": "Description",
            "key": "Description",
            "class": "col-span-3",
            "grow": true
        }],
        "attachedItems": {},
        "menuActions": [{ label: "Update Bug", action: editBug }, { label: "Close Bug", action: completeBug }]
    }
}];
